export default __webpack_public_path__ + "static/media/uqbar_tooltip.14a52859.png";